import { render } from "./MobileNavItem.vue?vue&type=template&id=041cbd58&scoped=true"
import script from "./MobileNavItem.vue?vue&type=script&lang=js"
export * from "./MobileNavItem.vue?vue&type=script&lang=js"

import "./MobileNavItem.vue?vue&type=style&index=0&id=041cbd58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041cbd58"]])

export default __exports__